export default {"src":"/_next/static/media/no_internet.8ed69bd9.svg","height":219,"width":352,"blurWidth":0,"blurHeight":0};